import { useTranslate } from "ra-core";

import { Button } from "@/components/ui/button";
import type { Contact } from "@/components/atomic-crm/types";
import { instagramUrl, whatsappUrl } from "./contactLinks";
import { QuickContactLog } from "./QuickContactLog";

type ContactWithHandle = Contact & { instagram_handle?: string | null };

// Contact page (task 1.9): WhatsApp for each number that can be trusted,
// Instagram from the handle, and "Log contact".
export const TenaxContactActions = ({
  contact,
}: {
  contact: ContactWithHandle;
}) => {
  const translate = useTranslate();
  const phones = (contact.phone_jsonb ?? [])
    .map((phone) => ({ number: phone.number, url: whatsappUrl(phone.number) }))
    .filter((phone): phone is { number: string; url: string } => !!phone.url);
  const instagram = instagramUrl(contact.instagram_handle);

  return (
    <div className="flex flex-wrap items-center gap-2">
      <QuickContactLog target="contact" targetId={contact.id} />
      {phones.map((phone) => (
        <Button key={phone.url} variant="outline" asChild>
          <a
            href={phone.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${translate("tenax.timeline.whatsapp")} ${phone.number}`}
          >
            {translate("tenax.timeline.whatsapp")}
            {phones.length > 1 ? ` ${phone.number}` : ""}
          </a>
        </Button>
      ))}
      {instagram ? (
        <Button variant="outline" asChild>
          <a href={instagram} target="_blank" rel="noopener noreferrer">
            {translate("tenax.timeline.instagram")}
          </a>
        </Button>
      ) : null}
    </div>
  );
};
